import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import MapPage from './pages/map-page';
import WebViewMap from "./pages/web-view-map";
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  createHashRouter,
  Routes,
  Navigate,
} from "react-router-dom";

const router = createHashRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Navigate to="/map-page" />} />
      <Route path="/map-page" element={<MapPage />} />
      <Route path="/web-view-map" element={<WebViewMap />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
